<template>
  <div id="app">
    <NavBar />
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div style="min-height: 400px">
        <router-view />
      </div>
    </transition>
    <FooterBar />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NavBar from '@/components/NavBar'
import FooterBar from '@/components/FooterBar'

export default {
  name: 'Home',
  components: {
    FooterBar,
    NavBar,
  },
  metaInfo: {
    titleTemplate: '%s | Media24 - Contech Media',
    htmlAttrs: {
      lang: 'en',
    },
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: "License the content you've always wanted within your budget",
      },
    ],
  },
  created() {
    this.isAuthenticated()
  },
  methods: {
    ...mapActions(['isAuthenticated']),
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },
  },
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100%;
  position: relative;
}

.footer {
  width: 100%;
  position: absolute;
  bottom: -120px;
  left: 0;
}
@media screen and (min-width: 768px) {
  .footer {
    bottom: -30px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
